import { INarrative } from './narrative';
import { IUser } from './user';

export interface ICharacter {
    uid: string,
    name: string,
    shortName: string,
    description: string,
    importance: string,
    gender: string,
    age: number,
    race: string,
    ethnicity: string,
    fileName: string,
    imageFile?: File,
    externalImageUrl?: string,
    status?: string,
    autoGenerated?: boolean,
    inUse?: boolean,

    selected?: boolean,

    narrative?: INarrative,
    author?: IUser,
    reviewer?: IUser,
}

export enum CharacterTypes {
    major = 'major',
    supporting = 'supporting',
    minor = 'minor',
}
